<template>
    <modal
      dialog
      ref="modal"
      class="confirm-modal"
      hide-close
      :title="title"
      size="sm"
      @close="handleClose"
    >
      <p>{{ message }}</p>

      <section class="modal-bottom button-row">
        <button type="reset" class="hollow" @click.stop="cancel">
          {{ cancelLabel }}
        </button>

        <button
          type="button"
          @click.stop="confirm"
          :class="['confirm-button', confirmButtonClass]"
        >
          {{ confirmLabel }}
        </button>
      </section>
    </modal>
</template>

<script>
import Modal from './Modal';

export default {
  name: 'ConfirmModal',

  components: {
    Modal,
  },

  data() {
    return {
      title: '',
      message: '',
      cancelLabel: 'Cancel',
      confirmLabel: 'OK',
      confirmButtonClass: 'failure',
    };
  },

  methods: {
    cancel() {
      this.$refs.modal.close();

      this.reject();
    },

    open() {
      this.$refs.modal.open();
    },

    confirm() {
      this.$refs.modal.close();

      this.$nextTick(() => {
        this.resolve();
      });
    },

    handleClose() {
      this.reject();
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .modal-bottom {
    margin-top: $gp * 1.5;
    width: 100%;
  }
</style>
